import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App';
// Apply theme before first paint so users don't see a light flash before dark mode kicks in.
import './theme';
// Apply the active color palette (cached instant, then background fetch to pick up admin changes).
import { initTheme } from './theme/apply';
initTheme();
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster position="top-right" />
    </BrowserRouter>
  </React.StrictMode>
);
